"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var builtins = __importStar(require("./__builtins__.json"));
var random = __importStar(require("./random.json"));
var matplotlib = __importStar(require("./matplotlib.json"));
var pandas = __importStar(require("./pandas.json"));
var sklearn = __importStar(require("./sklearn.json"));
var numpy = __importStar(require("./numpy.json"));
exports.DefaultSpecs = __assign({}, builtins, random, matplotlib, pandas, sklearn, numpy);
//# sourceMappingURL=index.js.map